<template>
    <div class="top-breadcrumbs">
        <p @click="handleGoIndex">运营指南</p>
        <div class="breadcrumbs-icon"></div>
        <span>发布项目更新</span>
    </div>
    <div class="cont top">
        <div class="title">为什么要发布项目更新？</div>
        <p>通过及时、详细地向支持者汇报项目进展情况，让他们了解项目的实际推进状态，从而增强对项目团队的信任。</p>
    </div>
    <div class="cont">
        <div class="title">项目更新可以发布什么内容？</div>
        <ul>
            <li>项目进展：是最主要的更新内容，包括但不限于：产品制作的进度、测试环节的结果/试玩视频、发货进度、解锁项公布、庆祝目标达成等等。</li>
            <li>收集反馈：项目更新为项目团队与支持者之间提供了一个互动的平台。在更新中，团队可以向支持者征求意见和建议，发起投票，了解支持者对项目的看法和期望，以便对项目进行优化和调整。</li>
            <li>活动同步：如果有做抽奖活动、种草活动也可以在更新中发布，吸引更多支持者参加活动。</li>
        </ul>
    </div>
    <div class="cont">
        <div class="title">更新发布频率是什么？</div>
        <p>项目众筹中，建议每周更新1次；项目众筹完成，建议每月发布2次；</p>
        <p class="tab_title" style="padding: 30px 0 20px 0;">更新展示位置（PC端）</p>
        <el-image 
            class="enlarged pc-image"
            :src="updatePc"
            :preview-src-list="imageList"
            :initial-index="0"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
        <p class="tab_title" style="padding: 60px 0 20px 0;">更新展示位置（移动端）</p>
        <el-image 
            class="enlarged app-image"
            :src="updateApp"
            :preview-src-list="imageList"
            :initial-index="1"
            :preview-teleported="true"
            fit="contain"
            loading="lazy"
        />
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

// 统一管理CDN地址
const CDN_BASE = 'https://p6.moimg.net/mdwxapp/guide/'

const updatePc = `${CDN_BASE}update_pc.png`
const updateApp = `${CDN_BASE}update_app.png`

// 图片列表，用于预览
const imageList = [updatePc, updateApp]

const router = useRouter()
const handleGoIndex = () => {
    if(sessionStorage.getItem('guide_pro_id')){
        router.push(`/project_manage/index/${sessionStorage.getItem('guide_pro_id')}`)
    } else {
        router.push((`/project_manage/index`))
    }
}
</script>

<style lang="scss" scoped>
.top-breadcrumbs{
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    padding: 0 0 40px 0;
    p{
        color: #7F7F7F;
        cursor: pointer;
    }
    .breadcrumbs-icon{
        width: 14px;
        height: 14px;
        margin: 0 10px;
        background: url('~@/assets/images/icon_right.png') no-repeat center center;
        background-size: contain;
    }
    span{
        color: #1A1A1A;
    }
}
.cont{
    margin: 60px 0 0 0;
    color: #1A1A1A;
    &.top{
        margin: 0;
    }
    &.img{
        .title{
            margin: 0;
        }
    }
    .title{
        font-size: 24px;
        font-weight: 600;
        margin: 0 0 15px 0;
    }
    .tab_title{
        font-weight: 600;
    }
    p{
        font-size: 14px;
        line-height: 21px;
        span{
            font-weight: 600;
        }
    }
    img{
        width: 100%;
        height: auto;
    }
    .el-image {
        height: auto;
        cursor: pointer;
        
        &.enlarged {
            transform: scale(1.2);
            transform-origin: center;
            transition: transform 0.3s ease;
        }
        
        &.pc-image {
            width: 667px;
            margin:40px 0 0 40px;
        }
        
        &.app-image {
            width: 230px;
            margin:20px 0 0 0;
        }
    }
    ul{
        padding-left: 20px;
        li{
            padding: 10px 0 0 0;
            list-style: disc;
        }
    }
}
</style>